import APIKit from "../Allapis/Apikit/apikit";

export const getAllBenefits = async (id) => {
    try {
      const url = id ? `/benefits/getbenefits/${id}` : `/benefits/getbenefits`;
      const res = await APIKit.get(url);  
      return res.data;
    } catch (e) {
      console.log(e);
    }
};

export const createBenefits = async (id, body) => {
    try {
      const url = id ? `/benefits/${id}` : `/benefits`;
      const res = await APIKit.post(url, body);  
      return res.data;
    } catch (e) {
      console.log(e);
    }
};